import * as countriesApi from "app/api/countriesApi";
import * as currenciesApi from "app/api/currenciesApi";
import * as registrationApi from "app/api/registrationApi";
import GeniusSiteTracking from "app/components/GeniusTracking/GeniusSiteTracking";
import { CountryHelper } from "app/helpers/countryHelper";
import { LanguageSelectionHelper } from "app/helpers/languageSelectionHelper";
import { passwordRegex } from "app/helpers/passwordHelper";
import { MercuryCountryType } from "app/types/countryType";
import { LossLimitsType, UserType } from "app/types/userType";
import React, { Component } from "react";
import cookie from "react-cookies";
import { FormattedMessage, injectIntl, IntlShape } from "react-intl";
import Footer from "../PublicScreen/components/Footer/Footer";
import AccountCurrency from "./components/AccountCurrency/AccountCurrency";
import AccountDetails from "./components/AccountDetails/AccountDetails";
import PersonalDetails from "./components/PersonalDetails/PersonalDetails";
import "./RegisterScreen.scss";
// test commit
type State = {
  accountDetailsActive: boolean;
  personalDetailsActive: boolean;
  accountCurrencyActive: boolean;
  username: string;
  password: string;
  email: string;
  firstName: string;
  middleName: string;
  lastName: string;
  dateOfBirth: string;
  nationality: string;
  nationalityId: number;
  nationalities: any;
  contactNumber: string;
  addressOne: string;
  addressTwo: string;
  addressThree: string;
  city: string;
  postCode: string;
  country: string;
  countryCode: string;
  countryId: number;
  countries: MercuryCountryType[];
  currencyId: number;
  currency: string;
  currencies: any;
  betRequirementsAccepted: boolean;
  ageDocumentationAccepted: boolean;
  recaptchaError: string;
  loading: boolean;
  accountDetailsError: string;
  personalDetailsError: string;
  accountCurrencyError: string;
  emailVerificationError: string;
  successful: boolean;
  heardAboutUs: string;
  consentToMarketing: boolean;
  promoCode: string;
  heardAboutUsOther: string;
  token: string;
  isVerified: boolean;
  lossLimits: LossLimitsType;
  lossLimitError: boolean;
};
type Props = {
  intl: IntlShape;
  user: UserType;
};

class RegisterScreen extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      accountDetailsActive: true,
      personalDetailsActive: false,
      accountCurrencyActive: false,
      username: "",
      password: "",
      email: "",
      firstName: "",
      middleName: "",
      lastName: "",
      dateOfBirth: "",
      nationality: "",
      nationalityId: 0,
      nationalities: [],
      contactNumber: "",
      addressOne: "",
      addressTwo: "",
      addressThree: "",
      city: "",
      postCode: "",
      country: "",
      countryCode: "",
      countryId: 0,
      countries: [],
      currencyId: 0,
      currency: "",
      currencies: [],
      betRequirementsAccepted: false,
      ageDocumentationAccepted: false,
      recaptchaError: "",
      loading: false,
      accountDetailsError: "",
      personalDetailsError: "",
      accountCurrencyError: "",
      emailVerificationError: "",
      successful: false,
      heardAboutUs: "",
      consentToMarketing: true,
      promoCode: "",
      heardAboutUsOther: "",
      token: "",
      isVerified: false,
      lossLimits: null,
    };

    this.getCountriesList();
    this.getNationalitiesList();
    this.getCurrenciesList();
  }

  componentDidMount() {
    this.loadPromoCode();
  }

  handleVerify = response => {
    if (response) {
      this.setState({ isVerified: true, token: response });
    }
  };

  handleExpire = () => {
    this.setState({ isVerified: false });
  };

  loadPromoCode = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const queryParamValue = queryParams.get("promoCode") || "";
    if (queryParamValue) {
      this.setState({ promoCode: queryParamValue });
    } else {
      const promoCode = cookie.load("promoCode") || "";
      this.setState({ promoCode });
    }
  };

  getCountriesList = () => {
    registrationApi.fetchCountriesForPublicRegistration().then(resp => {
      const formattedCountries = CountryHelper.formatCountriesFor3et(resp);
      this.setState({
        countries: formattedCountries,
      });
    });
  };
  getNationalitiesList = () => {
    countriesApi.fetchAllCountries().then(resp => {
      this.setState({
        nationalities: resp.countries,
      });
    });
  };

  getCurrenciesList = () => {
    currenciesApi.fetchRegistrationCurrencies().then(resp => {
      this.setState({
        currencies: resp.currencies,
      });
    });
  };

  handleCountryChange = (e: any) => {
    e.preventDefault();
    const selectedIndex = e.target.selectedIndex;
    if (selectedIndex >= 0) {
      const selectedOption = e.target.options[selectedIndex];
      this.setState(
        {
          countryId: e.target.value,
          country: selectedOption.text,
          countryCode: selectedOption.dataset.countrycode,
        },
        this.showCountrySpecificMessage
      );
    }
  };

  showCountrySpecificMessage = () => {
    // Use country code, as id seems to be different per env
    if (this.state.countryCode === "CA") {
      this.setState({
        personalDetailsActive: true,
        personalDetailsError: this.props.intl.formatMessage({
          id: "register-no-ontario",
        }),
      });
    } else {
      this.setState({
        personalDetailsError: "",
      });
    }
  };

  handleNationalityChange = (e: any) => {
    e.preventDefault();
    this.setState({
      nationalityId: e.target.value,
      nationality: e.target.options[e.target.selectedIndex].text,
    });
  };

  handleCurrencyChange = (e: any) => {
    e.preventDefault();
    this.setState({
      currencyId: e.target.value,
      currency: e.target.options[e.target.selectedIndex].text,
    });
  };

  handleDateChange = (e: any) => {
    this.setState({
      dateOfBirth: e.target.value,
    });
  };

  handleHeardAboutUsChange = (name: string) => {
    this.setState({
      heardAboutUs: name,
    });
  };

  handleChange = (id: string, value: string | boolean) => {
    this.setState(prevState => ({
      ...prevState,
      [id]: value,
    }));
  };

  handleCheckboxToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = e.currentTarget;
    this.setState(prevState => ({
      ...prevState,
      [id]: checked,
    }));
  };

  handleLimitChange = (id: string, value: LossLimitsType) => {
    this.setState(prevState => ({
      ...prevState,
      [id]: value,
    }));
  };

  toggleBetRequirements = (e: any) => {
    this.setState({
      betRequirementsAccepted: e.target.checked,
    });
  };
  toggleAgeDocumentation = (e: any) => {
    this.setState({
      ageDocumentationAccepted: e.target.checked,
    });
  };

  onClickConfirmAccountDetails = () => {
    if (this.validateAccountDetails()) {
      this.handleChange("accountDetailsActive", false);
      this.handleChange("personalDetailsActive", true);
    }
  };
  onClickConfirmPersonalDetails = () => {
    if (this.validatePersonalDetails()) {
      this.handleChange("personalDetailsActive", false);
      this.handleChange("accountCurrencyActive", true);
    }
  };

  onSubmit = (e: any) => {
    e.preventDefault();

    if (
      !this.validateAccountDetails() ||
      !this.validatePersonalDetails() ||
      !this.validateAccountCurrency()
    ) {
      return;
    }

    this.setState({
      loading: true,
    });

    registrationApi
      .createAccount({
        username: this.state.username,
        password: this.state.password,
        email: this.state.email,
        useIndividualPlayerDetails: true,
        firstName: this.state.firstName,
        middleName: this.state.middleName,
        lastName: this.state.lastName,
        dateOfBirth: this.state.dateOfBirth,
        nationality: this.state.nationalityId,
        contactNumber: this.state.contactNumber,
        addressLine1: this.state.addressOne,
        addressLine2: this.state.addressTwo,
        addressLine3: this.state.addressThree,
        city: this.state.city,
        postCode: this.state.postCode,
        country: this.state.countryId,
        currency: this.state.currencyId,
        awareOfMinimumDeposit: this.state.betRequirementsAccepted,
        over18AndWillVerifyId: this.state.ageDocumentationAccepted,
        gRecaptchaResponse: this.state.token,
        heardAboutUs:
          this.state.heardAboutUs === "other"
            ? `Other - ${this.state.heardAboutUsOther}`
            : this.state.heardAboutUs,
        consentToMarketing: this.state.consentToMarketing,
        promoCode: this.state.promoCode,
        language: LanguageSelectionHelper.checkSelectedLanguage(),
        affiliateType: cookie.load("affiliateType")
          ? cookie.load("affiliateType")
          : "",
        lossLimits: this.state.lossLimits,
      })

      .then(() => {
        this.setState({
          loading: false,
          successful: true,
          accountCurrencyError: "",
        });
      })
      .catch(error => {
        console.log("error :", error);
        let errorMessage = "";
        // Error structure is different depending on whether it's verification error or network error
        if (error.response?.data?.message) {
          errorMessage = error.response.data.message;
        } else if (
          error.response?.data &&
          error.response?.data[0]?.dataType &&
          error.response?.data[0]?.message
        ) {
          errorMessage = `${error.response.data[0]?.dataType}: ${error.response.data[0]?.message}`;
        } else if (error.message) {
          errorMessage = error.message;
        }
        this.setState({
          loading: false,
          accountCurrencyError: errorMessage,
        });
        window.grecaptcha.reset();
      });
  };

  validateAccountDetails = () => {
    const { username, password, email } = this.state;
    let errorMessage = "";
    let emailError = "";
    let emailRegex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isEmailValid = emailRegex.test(String(email).toLowerCase());
    // Password validation
    const isPasswordValid = passwordRegex.test(password);
    if (!username.length || !password.length || !email.length) {
      errorMessage = `Missing values: ${
        !username.length ? "'Username' " : ""
      } ${!password.length ? "'Password' " : ""} ${
        !email.length ? "'Email'" : ""
      }`;

      this.setState({
        accountDetailsActive: true,
        accountDetailsError: errorMessage,
      });
      return false;
    } else if (!isPasswordValid) {
      errorMessage = this.props.intl.formatMessage({
        id: "password-validation-message",
        defaultMessage:
          "Password must be 8-50 characters long and contain at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character",
      });
      this.setState({
        accountDetailsActive: true,
        accountDetailsError: errorMessage,
      });
      return false;
    } else if (!isEmailValid) {
      if (!isEmailValid) {
        emailError = "Invalid email address";
      }
      this.setState({
        accountDetailsActive: true,
        accountDetailsError: errorMessage,
        emailVerificationError: emailError,
      });
      return false;
    } else {
      this.setState({
        accountDetailsError: errorMessage,
      });
      return true;
    }
  };
  validatePersonalDetails = () => {
    const {
      firstName,
      lastName,
      dateOfBirth,
      contactNumber,
      addressOne,
      city,
      postCode,
      countryId,
      nationalityId,
    } = this.state;
    let errorMessage = "";

    if (
      !firstName.length ||
      !lastName.length ||
      !dateOfBirth.length ||
      !contactNumber.length ||
      !addressOne.length ||
      !city.length ||
      !postCode.length ||
      !countryId ||
      !nationalityId
    ) {
      errorMessage = `Missing values: ${
        !firstName.length ? "'First Name' " : ""
      } ${!lastName.length ? "'Last Name' " : ""} ${
        !dateOfBirth.length ? "'Date of Birth' " : ""
      }
      ${!contactNumber.length ? "'Contact Number' " : ""}
      ${!countryId ? "'Country' " : ""}
      ${!nationalityId ? "'Nationality' " : ""}
      ${!addressOne.length ? "'Address' " : ""}
      ${!city.length ? "'City' " : ""}
      ${!postCode.length ? "'Post Code' " : ""}`;

      this.setState({
        personalDetailsActive: true,
        personalDetailsError: errorMessage,
      });

      return false;
    } else {
      this.setState({
        personalDetailsError: errorMessage,
      });
      return true;
    }
  };
  validateAccountCurrency = () => {
    const {
      currencyId,
      betRequirementsAccepted,
      ageDocumentationAccepted,
      heardAboutUs,
      heardAboutUsOther,
      lossLimitError,
    } = this.state;
    let errorMessage = "";
    const intl = this.props.intl as IntlShape;
    if (!currencyId) {
      errorMessage = "Missing Values: 'Currency'";
      this.setState({
        accountCurrencyError: errorMessage,
      });
      return false;
    } else if (!heardAboutUs) {
      errorMessage =
        "Please choose an option to indicate how you found out about 3ET.";
      this.setState({
        accountCurrencyError: errorMessage,
      });
    } else if (heardAboutUs === "other" && !heardAboutUsOther) {
      const errorMessage = this.props.intl.formatMessage({
        id: "register-heardaboutus-specify",
        defaultMessage: "If Other selected, please specify",
      });
      this.setState({
        accountCurrencyError: errorMessage,
      });
    } else if (!betRequirementsAccepted || !ageDocumentationAccepted) {
      errorMessage =
        "Documention Requirements and Minimum Deposit Requirements need to be selected";
      this.setState({
        accountCurrencyError: errorMessage,
      });

      return false;
    } else if (lossLimitError) {
      const errorMessage = intl.formatMessage({
        id: "number-input-error-message",
        defaultMessage: "Please enter a valid number",
      });
      this.setState({
        accountCurrencyError: errorMessage,
      });
      return false;
    } else {
      this.setState({
        accountCurrencyError: errorMessage,
      });

      return true;
    }
  };

  render() {
    const {
      dateOfBirth,
      countryId,
      countries,
      nationalities,
      nationalityId,
      currencyId,
      currencies,
      accountDetailsActive,
      personalDetailsActive,
      accountCurrencyActive,
      recaptchaError,
      loading,
      accountDetailsError,
      personalDetailsError,
      accountCurrencyError,
      emailVerificationError,
      successful,
    } = this.state;
    const { intl } = this.props;

    return (
      <div className="register-screen">
        <div className="register-screen__form">
          {!successful ? (
            <React.Fragment>
              <h3>
                <FormattedMessage id="home-register-welcome" />
              </h3>
              <AccountDetails
                handleChange={this.handleChange}
                active={accountDetailsActive}
                onClickConfirm={this.onClickConfirmAccountDetails}
                errorMessage={accountDetailsError}
                emailErrorMessage={emailVerificationError}
              />
              <PersonalDetails
                handleChange={this.handleChange}
                handleDateChange={this.handleDateChange}
                active={personalDetailsActive}
                onClickConfirm={this.onClickConfirmPersonalDetails}
                dateOfBirth={dateOfBirth}
                countryId={countryId}
                countries={countries}
                nationalities={nationalities}
                nationalityId={nationalityId}
                handleNationalityChange={this.handleNationalityChange.bind(
                  this
                )}
                handleCountryChange={this.handleCountryChange.bind(this)}
                errorMessage={personalDetailsError}
                city={this.state.city}
                intl={intl}
              />
              <AccountCurrency
                handleChange={this.handleChange}
                active={accountCurrencyActive}
                currencyId={currencyId}
                currencies={currencies}
                handleCurrencyChange={this.handleCurrencyChange}
                onSubmit={this.onSubmit}
                handleCheckboxToggle={this.handleCheckboxToggle}
                recaptchaError={recaptchaError}
                loading={loading}
                errorMessage={accountCurrencyError}
                handleHeardAboutUsChange={this.handleHeardAboutUsChange}
                consentToMarketing={this.state.consentToMarketing}
                betRequirementsAccepted={this.state.betRequirementsAccepted}
                ageDocumentationAccepted={this.state.ageDocumentationAccepted}
                promoCode={this.state.promoCode}
                intl={intl}
                heardAboutUs={this.state.heardAboutUs}
                heardAboutUsOther={this.state.heardAboutUsOther}
                handleVerify={this.handleVerify}
                handleExpire={this.handleExpire}
                lossLimits={this.state.lossLimits}
                handleLimitChange={this.handleLimitChange}
              />
            </React.Fragment>
          ) : (
            <div className="register-screen__form__successful">
              <GeniusSiteTracking
                targetSelector=".register-screen__form__successful"
                eventType="change"
                pageName="regconfirm"
                trackPageLoad={true}
              />
              <h3>
                <FormattedMessage id="home-account-register-successful" />
              </h3>
              <FormattedMessage id="home-account-register-check-email" />
            </div>
          )}
        </div>
        <Footer />
      </div>
    );
  }
}

export default injectIntl(RegisterScreen) as any;
